import { render, staticRenderFns } from "./dishCard.vue?vue&type=template&id=35806923&scoped=true"
import script from "./dishCard.vue?vue&type=script&lang=js"
export * from "./dishCard.vue?vue&type=script&lang=js"
import style0 from "./dishCard.vue?vue&type=style&index=0&id=35806923&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35806923",
  null
  
)

export default component.exports